import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CompetitionBuyVotesContent from "./CompetitionBuyVotesContent";

export default function CompetitionBuyVotes({
  open,
  onClose,
  competitionId,
  competitionName,
  votePurchase,
  token,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          bgcolor: "#242743",
          color: "#fff",
          border: "1px solid #414466",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <ShoppingCartOutlinedIcon sx={{ color: "#FFCD1F" }} />
          <Typography sx={{ fontWeight: 800, fontSize: 18 }}>
            Buy votes
          </Typography>
        </Stack>
        <IconButton onClick={onClose} sx={{ color: "#fff" }} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 3 }}>
        <CompetitionBuyVotesContent
          competitionId={competitionId}
          competitionName={competitionName}
          votePurchase={votePurchase}
          token={token}
        />
      </DialogContent>
    </Dialog>
  );
}
